import { Union } from "../../fable_modules/fable-library-js.4.25.0/Types.js";
import { union_type, string_type } from "../../fable_modules/fable-library-js.4.25.0/Reflection.js";
import { ofArray } from "../../fable_modules/fable-library-js.4.25.0/List.js";
import { FormData_tryParse, Extensions_String_$007CPrefix$007C_$007C } from "../Shared.js";
import { ResultComputationExpression_result, ResultComputationExpression_ResultBuilder__Return_1505, ResultComputationExpression_ResultBuilder__Bind_764BA1D3, ResultComputationExpression_ResultBuilder__Delay_1505, ResultComputationExpression_ResultBuilder__Run_FCFD9EF } from "../../fable_modules/AsyncResult.0.3.0/Result.fs.js";
import { Validate_String_standardValidate } from "../../ThreeDocs.SharedUI/FormValidation.js";
import { map } from "../../fable_modules/fable-library-js.4.25.0/Option.js";
import { ComponentVisibility } from "../../ThreeDocs.SharedUI/ComponentVisibility.js";

export class PracticeType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Individual", "Group", "IndependentHealthFacility", "Hospital", "Other_specify_string"];
    }
}

export function PracticeType_$reflection() {
    return union_type("ThreeDocs.Models.Domain.PracticeType.PracticeType", [], PracticeType, () => [[], [], [], [], [["Item", string_type]]]);
}

export function PracticeType_get_viewDisplay() {
    return (_arg) => ((_arg.tag === 1) ? "Group" : ((_arg.tag === 2) ? "Independent Health Facility" : ((_arg.tag === 3) ? "Hospital" : ((_arg.tag === 4) ? (`Other (${_arg.fields[0]})`) : "Individual"))));
}

export function PracticeType_get_dropdownDisplay() {
    return (_arg) => ((_arg.tag === 4) ? "Other (Specify)" : PracticeType_get_viewDisplay()(_arg));
}

export function PracticeType_get_internalDescribe() {
    return (_arg) => ((_arg.tag === 1) ? "Group" : ((_arg.tag === 2) ? "IndependentHealthFacility" : ((_arg.tag === 3) ? "Hospital" : ((_arg.tag === 4) ? (`Other_specify_string ${_arg.fields[0]}`) : "Individual"))));
}

export function PracticeType_get_all() {
    return ofArray([new PracticeType(0, []), new PracticeType(1, []), new PracticeType(2, []), new PracticeType(3, []), new PracticeType(4, [""])]);
}

export function PracticeType_get_tryParse() {
    return (_arg) => {
        let activePatternResult, other;
        return (activePatternResult = Extensions_String_$007CPrefix$007C_$007C(PracticeType_get_internalDescribe()(new PracticeType(4, [""])), _arg), (activePatternResult != null) ? ((other = activePatternResult, new PracticeType(4, [other]))) : FormData_tryParse(PracticeType_get_internalDescribe(), PracticeType_get_all(), _arg));
    };
}

export function PracticeType_validate_Z5A6B7DD1(maybePracticeType) {
    return ResultComputationExpression_ResultBuilder__Run_FCFD9EF(ResultComputationExpression_result, ResultComputationExpression_ResultBuilder__Delay_1505(ResultComputationExpression_result, () => {
        let other;
        return (maybePracticeType != null) ? ((maybePracticeType.tag === 4) ? ((other = maybePracticeType.fields[0], ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, Validate_String_standardValidate("Practice Type Other (Specify)")(other), (_arg) => ResultComputationExpression_ResultBuilder__Return_1505(ResultComputationExpression_result, maybePracticeType)))) : ResultComputationExpression_ResultBuilder__Return_1505(ResultComputationExpression_result, maybePracticeType)) : ResultComputationExpression_ResultBuilder__Return_1505(ResultComputationExpression_result, maybePracticeType);
    }));
}

export function PracticeType_get_other_() {
    return [(_arg) => {
        let other;
        return (_arg != null) ? ((_arg.tag === 4) ? ((other = _arg.fields[0], other)) : undefined) : undefined;
    }, (option) => map((Item) => (new PracticeType(4, [Item])), option)];
}

export function PracticeType_get_otherSelected() {
    return (_arg) => ((_arg != null) ? ((_arg.tag === 4) ? (new ComponentVisibility(0, [])) : (new ComponentVisibility(1, []))) : (new ComponentVisibility(1, [])));
}

